import React from "react";

import isIntuit from "Intuit/isIntuit";

import CobaltButton, { LinkButton as CobaltLinkButton } from "Cobalt/Button";
import ClassicButton from "Common/Button";

import { useThemeContext } from "./Context";

const Button = ({ children, cobaltProps = {}, classicProps = {}, intuitProps = {}, ...rest }) => {
  const { intuit, cobalt } = useThemeContext();
  return isIntuit() && intuit ? (
    <ClassicButton {...rest} {...intuitProps}>
      {children}
    </ClassicButton>
  ) : cobalt ? (
    <CobaltButton {...rest} {...cobaltProps}>
      {children}
    </CobaltButton>
  ) : (
    <ClassicButton {...rest} {...classicProps}>
      {children}
    </ClassicButton>
  );
};

export const LinkButton = ({ children, cobaltProps = {}, classicProps = {}, intuitProps = {}, ...rest }) => {
  const { intuit, cobalt } = useThemeContext();
  return isIntuit() && intuit ? (
    <ClassicButton {...rest} {...intuitProps}>
      {children}
    </ClassicButton>
  ) : cobalt ? (
    <CobaltLinkButton {...rest} {...cobaltProps}>
      {children}
    </CobaltLinkButton>
  ) : (
    <ClassicButton {...rest} {...classicProps}>
      {children}
    </ClassicButton>
  );
};

export default Button;
